import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {useLang} from '../../context/LanguageContext';
import BgImage from '../../images/games_bg.png';
import {useAuth} from "../../context/AuthContext";
import {useData} from "../../context/DataContext";
import DateUtils from "../../utils/dateUtils";
import Footer from "../../components/Footer";
import BackGreenButton from "../../components/BackGreenButton";
import ArrayOfObjects from "../../utils/arrayOfObjects";
import DateAscIcon from "../../assets/icons/DateAscIcon";
import DateDescIcon from "../../assets/icons/DateDescIcon";

const PredictionsPage = () => {
  const navigate = useNavigate();
  const { games: gamesDb } = useData();
  const { hasPaid } = useAuth();
  const { t, getBetTranslation } = useLang();
  const [games, setGames] = useState([]);
  const [dayFilter, setDayFilter] = useState('all');
  const [dateOrder, setDateOrder] = useState("asc");
  const [filteredGames, setFilteredGames] = useState([]);
  const [possibleDays, setPossibleDays] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (gamesDb){
      const sortedGamesDb = ArrayOfObjects.sortGamesByApiDay(gamesDb).map(game => {
        return {
          ...game,
          translatedMarketName: getBetTranslation(game.marketName),
          translatedMarket: getBetTranslation(game.market),
        }
      });

      setGames(sortedGamesDb);

      const dayCodes = new Set();
      sortedGamesDb.forEach((g) => {
        const code = DateUtils.getDayCode(g.day);
        if (code){
          dayCodes.add(code);
        }
      });

      const uniqueDayCodes = Array.from(dayCodes);

      const dayOptions = uniqueDayCodes.map((code) => {
        const label = DateUtils.getDayLabel(code);
        return { code, label };
      });
      setPossibleDays(dayOptions);
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gamesDb]);

  useEffect(() => {
    if(games.length > 0){
        const sign1 = dateOrder === "asc" ? 1 : -1;
        const sign2 = dateOrder === "desc" ? 1 : -1;
      setFilteredGames(
          games.filter((game) => {
            if (dayFilter === 'all') return true;
            const code = DateUtils.getDayCode(game.day);
            return code === dayFilter;
          }).sort((gameA, gameB) => {
              if(gameA.dayTemp > gameB.dayTemp){
                  return sign1;
              }
              if(gameA.dayTemp < gameB.dayTemp){
                  return sign2;
              }
              return gameA.hour > gameB.hour ? sign1 : sign2
          })
      );
    }
  }, [games, dayFilter, dateOrder])

  if (!games) {
    return (
      <div className="bg-gray-100 min-h-screen flex flex-col items-center justify-center">
          <BackGreenButton />
        <div>Loading matches...</div>
      </div>
    );
  }

  return (
      <div className="bg-[#34495e] min-h-screen p-5 relative">
        <BackGreenButton/>

        <h1 className="text-xl text-white font-bold text-center mt-16 mb-8">
          {t('txt.normalPredTitle')}
        </h1>
        <div className="max-w-xs mx-auto mb-4 flex items-end">
          <div className="flex-1">
            <label className="block mb-1 font-semibold text-sm text-white">
              {t('txt.filterDays')}
            </label>
            <select
                className="w-full border border-gray-300 rounded px-2 py-1"
                value={dayFilter}
                onChange={(e) => setDayFilter(e.target.value)}
            >
              <option value="all">{t('txt.selectDays')}</option>
              {possibleDays.map((opt) => (
                  <option key={opt.code} value={opt.code}>
                    {opt.label}
                  </option>
              ))}
            </select>
          </div>
          <div
              className="mx-2 bg-[#2ecc71] cursor-pointer rounded-md py-1 px-3 h-[33px]"
              onClick={() => {
                  setDateOrder((prevState) => prevState === "asc" ? "desc" : "asc")
              }}
          >
            {dateOrder === "asc" &&
                <DateDescIcon />
            }
            {dateOrder === "desc" &&
                <DateAscIcon />
            }
          </div>
        </div>

        <div className="space-y-4">
          {filteredGames.map((game) => {
            return (
                <div
                    key={game.id}
                    className="
                relative
                rounded
                shadow
                p-4
                border-r-2 border-[#27ae60]
                text-white
                bg-cover bg-center
                min-h-[120px]
              "
                    style={{backgroundImage: `url(${BgImage})`}}
                >
                  <div className="flex items-center mb-2">
                    {game.flag && (
                        <img
                            src={game.flag}
                            alt="Flag"
                            className="w-6 h-6 mr-2"
                        />
                    )}
                    <span className="font-bold text-sm">{game.countryName}</span>
                  </div>

                  <div className="flex items-center text-sm mb-2">
                    <span className="mr-4">{DateUtils.formatDayOnly(game.day, t)}</span>
                    <span>{game.hour}</span>
                  </div>

                  <div className="font-semibold text-sm mb-2">
                    {game.team1} vs {game.team2}
                  </div>

                  <hr className="border-gray-300 mx-4 mb-2"/>

                  {hasPaid ? (
                      <div className="flex flex-col md:items-end">
                  <span className="text-sm">
                    {game.translatedMarketName} ({game.translatedMarket})
                  </span>
                        <span className="text-lg font-bold text-green-300">
                    {game.odd}
                  </span>
                      </div>
                  ) : (
                      <button
                          onClick={() => navigate('/account')}
                          className="px-3 py-1 bg-blue-500 text-white rounded text-sm"
                      >
                        {t('btn.unlockPremium')}
                      </button>
                  )}
                </div>
            );
          })}

          {filteredGames.length === 0 && (
              <p className="text-center text-gray-200">
                No matches found for this day.
              </p>
          )}
        </div>
        <Footer/>
      </div>
  );
};

export default PredictionsPage;
